module.exports = __webpack_public_path__ + "img/ciclic-negativo.80ab207c.svg";